<template>
  <div v-if="paging.total">
    <div class="d-flex justify-content-between position-relative" :style="{paddingLeft: padding, paddingRight: padding}">
      <div class="d-flex justify-content-between h-100 mt-3">
        <span>{{ label }} <span class="lable">{{ paging.total }} {{ unitLabel }}</span></span>
      </div>
      <div style="margin-top: -10px;" >
        <ul class="pagination pagination-rounded justify-content-center mt-4">
          <!-- Previous Button -->
          <li class="page-item">
            <a :class="{ disabled: paging.current_page === 1 }" href="javascript:void(0)"
               @click="$emit('change', paging.current_page > 1 ? paging.current_page - 1 : 1)" class="page-link px-2 single-line">
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>

          <!-- First Page and Leading Ellipsis -->
          <li v-if="startPage > 1" class="page-item">
            <a href="javascript:void(0)" @click="$emit('change', 1)" class="page-link px-2 single-line">1</a>
          </li>
          <li v-if="startPage > 2" class="page-item disabled">
            <span class="page-link">...</span>
          </li>

          <!-- Page Numbers -->
          <li v-for="n in pagesToShow" :key="n" class="page-item" :class="{ active: n === paging.current_page }">
            <a href="javascript:void(0)" @click="$emit('change', n)" class="page-link px-2 single-line">{{ n }}</a>
          </li>

          <!-- Trailing Ellipsis and Last Page -->
          <li v-if="endPage < paging.last_page - 1" class="page-item disabled">
            <span class="page-link">...</span>
          </li>
          <li v-if="endPage < paging.last_page" class="page-item">
            <a href="javascript:void(0)" @click="$emit('change', paging.last_page)" class="page-link px-2 single-line">{{ paging.last_page }}</a>
          </li>

          <!-- Next Button -->
          <li class="page-item">
            <a :class="{ disabled: paging.current_page === paging.last_page }" href="javascript:void(0)"
               @click="$emit('change', paging.current_page === paging.last_page ? paging.last_page : paging.current_page + 1)"
               class="page-link px-2">
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="d-flex flex-column justify-content-center text-muted h-100 mt-3">
        <span class="text-muted">
          {{ paging.total }}の{{ paging.from }}-{{ paging.to }}を表示しています
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['paging', 'theme', 'label', 'unitLabel', 'padding'],
  computed: {
    startPage() {
      if (this.paging.current_page <= 5) return 1;
      if (this.paging.current_page >= this.paging.last_page - 4) return this.paging.last_page - 5;
      return this.paging.current_page - 3;
    },
    endPage() {
      if (this.paging.current_page <= 5) return Math.min(7, this.paging.last_page);
      if (this.paging.current_page >= this.paging.last_page - 4) return this.paging.last_page;
      return this.paging.current_page + 3;
    },
    pagesToShow() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    activeColor() {
      return this.theme === 'normal' ? '#7cc31c' : '#395299';
    }
  }
};
</script>

<style scoped>
.pagination .disabled {
  pointer-events: none;

}
.pagination .active .page-link {
  background-color: v-bind(activeColor);
  color: white;
}
.lable{
  color:v-bind(activeColor);
}
.single-line {
  white-space: nowrap !important;
}
</style>
